import React from 'react';
import TestimonialQuote from './components/TestimonialQuote/TestimonialQuote';
import TestimonialVideo from './components/TestimonialVideo/TestimonialVideo';
import TestimonialCaption from './components/TestimonialCaption/TestimonialCaption';
import TestimonialPicture from './components/TestimonialPicture/TestimonialPicture';
import YoutubePopup from '../../components/YoutubePopup/YoutubePopup';
import * as styles from './TestimonialTile.module.scss';
const TestimonialTile = ({
  color,
  caption,
  quote,
  instagram,
  name,
  picture,
  pictureHover,
  productName,
  variant,
  youtube,
  video
}) => {
  var _youtube$thumbnail;
  const Component = instagram !== null && instagram !== void 0 && instagram.href && !(instagram !== null && instagram !== void 0 && instagram.label) ? 'a' : 'div';
  return (/*#__PURE__*/
    // eslint-disable-next-line max-len
    React.createElement(Component, {
      href: instagram !== null && instagram !== void 0 && instagram.href && !(instagram !== null && instagram !== void 0 && instagram.label) ? instagram.href : null,
      rel: instagram !== null && instagram !== void 0 && instagram.href && !(instagram !== null && instagram !== void 0 && instagram.label) ? 'noopener noreferrer nofollow' : null,
      target: instagram !== null && instagram !== void 0 && instagram.href && !(instagram !== null && instagram !== void 0 && instagram.label) ? 'blank' : null,
      className: `${styles.root} ${color ? styles[`root${color}`] : ''}
      ${variant ? styles[`root${variant}`] : ''}`
    }, /*#__PURE__*/React.createElement("figure", {
      className: styles.rootFigure
    }, quote && /*#__PURE__*/React.createElement(TestimonialQuote, {
      quote: quote
    }), (name || caption || (instagram === null || instagram === void 0 ? void 0 : instagram.label) || productName) && /*#__PURE__*/React.createElement(TestimonialCaption, {
      productName: variant !== 'Image' ? productName : null,
      name: name,
      caption: caption,
      instagram: instagram
    })), ((picture === null || picture === void 0 ? void 0 : picture.caption) || (picture === null || picture === void 0 ? void 0 : picture.xs)) && /*#__PURE__*/React.createElement(TestimonialPicture, {
      productName: variant === 'Image' ? productName : null,
      picture: picture,
      pictureHover: pictureHover,
      caption: picture === null || picture === void 0 ? void 0 : picture.caption
    }), ((video === null || video === void 0 ? void 0 : video.thumbnail) || (youtube === null || youtube === void 0 ? void 0 : (_youtube$thumbnail = youtube.thumbnail) === null || _youtube$thumbnail === void 0 ? void 0 : _youtube$thumbnail.src)) && /*#__PURE__*/React.createElement(TestimonialVideo, {
      video: video,
      youtube: youtube
    }))
  );
};
export default TestimonialTile;